<template>

        <div class="container services">
            <h2 class="text-center">{{ trans('services.title_' + $root.network) }}</h2>
            <my-carousel
                v-if="is_ie"
                :per-page-custom="[[0, 1], [768, 2], [991, 2], [1190, 3]]"
                ref="services_carousel"
            >
                <div
                    v-for="(section, section_index) in config"
                    :key="section_index"
                    class="carousel-card mx-auto px-1 text-center"
                >
                    <div class="img-service">
                        <img :src="'/img/services/' + trans('services.' + section_index + '.img') + '.jpg'" :alt="trans('services.' + section_index + '.title')" width="477" height="256">
                    </div>
                    <div class="p-3">
                        <h2>{{ trans('services.' + section_index + '.title') }}</h2>
                        <p>{{ trans('services.' + section_index + '.text') }}</p>
                        <a class="btn btn-network btn-md" :href="trans('services.' + section_index + '.href')">{{ trans('services.button') }}</a>
                    </div>
                </div>
            </my-carousel>

            <my-carousel
                v-else
                :per-page-custom="[[0, 1], [768, 2], [991, 2], [1190, 3]]"
                ref="services_carousel"
                v-waypoint="{ active: true, callback: toggleAnimated, options: intersectionOptions }"
                @page-change="animateSlide"
            >
                <slide
                    v-for="(section, section_index) in config"
                    :key="section_index"
                    v-if="section == 1 | (section == 2 & $root.is_mobile2)"
                >
                    <div
                        class="carousel-card mx-auto px-1 text-center"
                        @mouseenter.prevent.stop="mouseEnter(section_index)"
                        @mouseleave.stop="mouseLeave(section_index)"
                    >
                        <div class="img-service">
                            <img :src="'/img/services/' + trans('services.' + section_index + '.img') + '.jpg'" :alt="trans('services.' + section_index + '.title')" width="477" height="256">
                            <!-- <img :src="'/img/services/' + trans('services.' + section_index + '.img') + '-animated.jpg'" :alt="trans('services.' + section_index + '.title')" v-if="animated[section_index]" class="hover" width="477" height="256"> -->
                        </div>
                        <div class="p-3">
                            <h2>{{ trans('services.' + section_index + '.title') }}</h2>
                            <p>{{ trans('services.' + section_index + '.text') }}</p>
                            <a
                                class="btn btn-network btn-md"
                                :href="trans('services.' + section_index + '.href')"
                                :target="trans('services.' + section_index + '.target') ? trans('services.' + section_index + '.target') : null"
                            >{{ trans('services.button') }}</a>
                        </div>
                    </div>
                </slide>
            </my-carousel>

            <my-carousel
                v-if="!$root.is_mobile2 & config.sell == 2 & config.rent == 2"
                :per-page-custom="[[0, 1], [768, 2], [991, 2], [1190, 3]]"
                ref="services_carousel"
                v-waypoint="{ active: true, callback: toggleAnimated, options: intersectionOptions }"
                @page-change="animateSlide"
                class="sell-rent"
            >
                <slide
                    v-for="(section, section_index) in config"
                    :key="section_index"
                    v-if="section == 2"
                >
                    <div
                        class="carousel-card px-1 text-center"
                    >
                        <div class="img-service">
                            <img :src="'/img/services/' + trans('services.' + section_index + '.img') + '.jpg'" :alt="trans('services.' + section_index + '.title')" width="477" height="256">
                        </div>
                        <div class="p-3">
                            <h2>{{ trans('services.' + section_index + '.title') }}</h2>
                            <p>{{ trans('services.' + section_index + '.text') }}</p>
                            <a class="btn btn-network btn-md" target="blank" :href="trans('services.' + section_index + '.href')">{{ trans('services.button') }}</a>
                        </div>
                    </div>

                </slide>
            </my-carousel>
        </div>

</template>

<script>
// import VueWaypoint from "vue-waypoint"

import MyCarousel from './MyCarousel'

import { getBrowser } from '../helpers/browsers'

export default {

    props: {
        config: {
            type: Object,
            required: true,
        }
    },

    components: {
        'my-carousel': MyCarousel,
    },

    data() {
        return {
            animated: {
                visit: false,
                evaluation_estate: false,
                work: false,
            },
            is_ie: false,
            initialized: false,
            services: ['visit', 'evaluation_estate', 'work'],
            intersectionOptions: {
                root: null,
                rootMargin: '0px 0px 0px 0px',
                threshold: [0.25, 0.75]
            }
        }
    },

    computed: {
        lang() {
            return this.$root.lang.home
        },
    },

    mounted() {
        this.is_ie = getBrowser() == 'ie'
    },

    methods:{
        toggleAnimated({ el, going, direction, _entry }) {
           if (!this.initialized && going === this.$waypointMap.GOING_IN && _entry.intersectionRatio > 0.28) {
                this.initialized = true

                this.animate('visit')

                setTimeout(
                    () => {
                        this.animate('evaluation_estate')
                        setTimeout(
                            () => {
                                this.animate('work')
                            },
                            350
                        )
                    },
                    350
                )
            }
        },

        animate(key) {
            this.animatedOn(key)

            setTimeout(
                () => {
                    this.animatedOff(key)
                },
                this.$root.is_mobile ? 5000 : 3000
            )
        },

        mouseEnter(key) {
            if (!this.$root.is_mobile) {
                this.animatedOn(key)
            }
        },

        mouseLeave(key) {
            if (!this.$root.is_mobile) {
                this.animatedOff(key)
            }
        },

        animatedOn(key) {
            this.animated[key] = true
        },

        animatedOff(key) {
            this.animated[key] = false
        },

        animateSlide(event) {
            if (this.$root.is_mobile) {
                this.animate(this.services[event])
            }
        },
    }
}
</script>